module.exports = __webpack_public_path__ + "static/media/galerija_2019 (31).8a490e35.jpg";